import Select, { components } from "react-select";
import * as statusIcons from "../Icons/status";
import { Check } from "../Icons/general-interface-1";
import styles from "./index.module.scss";
import { statusList, statusType, findStatus } from "../../utils/status/index";

type PropsType = {
  status: statusType;
  onStatusChange: (status: statusType) => void;
  options?: { value: statusType; label: string }[];
};

function KeyedIcon(props) {
  const IconComponent = props.name ? statusIcons[props.name] : () => null;
  return <IconComponent className={props.style} />;
}

// -- Custom Components & Styles for react-styles --
const { Option, Control } = components;

const IconOption = (props) => (
  <Option {...props}>
    <KeyedIcon name={props.data.value} style={styles.iconOptions} />
    <div style={{ display: "inline-block", width: "80%" }}>
      {props.data.label}
    </div>
    {props.isSelected && <Check className={styles.iconCheck} />}
  </Option>
);

const IconControl = (props) => (
  <Control {...props}>
    <KeyedIcon name={props.getValue()[0].value} style={styles.iconControl} />
    {props.children}
  </Control>
);

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    width: "235px",
    background: "transparent",
    padding: "0 10px",
    border: `2px solid ${styles.blue_200}`,
    boxShadow: state.isFocused
      ? `0px 0px 0px 3px ${styles.yellow_active_40}`
      : "0px 0px 0px 3px transparent",
    borderRadius: "50px",

    "&:hover": {
      background: styles.blue_100,
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "black",
    transition: "transform 100ms ease-in-out",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    color: styles.grey_400,
    width: "100%",
    padding: "15px",
    background: state.isFocused ? styles.blue_100 : "transparent",
  }),
  menu: (provided) => ({
    ...provided,
    width: "250px",
    border: `2px solid ${styles.blue_200}`,
    borderRadius: "4px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: styles.grey_400,
  }),
};

const StatusPillDropdown = ({ status, onStatusChange, options }: PropsType) => {
  const selectedOption = findStatus(status);

  const onDropdownSelect = (selection) => {
    onStatusChange(selection.value);
  };

  return (
    <div className={styles.text}>
      <Select
        styles={customStyles}
        classNamePrefix="statusPillDropdown"
        value={selectedOption}
        onChange={onDropdownSelect}
        options={options || statusList}
        maxMenuHeight="197px"
        openMenuOnFocus
        blurInputOnSelect
        isSearchable={false}
        components={{
          Option: IconOption,
          Control: IconControl,
        }}
      />
    </div>
  );
};

export default StatusPillDropdown;
